import * as React from 'react';

function SvgVideoBg(props) {
  return (
    <svg viewBox="0 0 265 286" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M261.136 125c2.07 0 3.756 1.608 3.859 3.635l.005.198v153.331c0 2.053-1.62 3.728-3.665 3.831l-.2.005H17.862c-2.068 0-3.753-1.611-3.856-3.639l-.005-.197V128.833c0-2.053 1.62-3.725 3.662-3.828l.199-.005zM139.5 155.67c-27.723 0-50.197 22.31-50.197 49.83 0 27.508 22.474 49.83 50.197 49.83 27.72 0 50.197-22.322 50.197-49.83 0-27.524-22.474-49.83-50.197-49.83zm-11.478 14.651l.139.1 42.107 33.085c.462.362.732.908.732 1.492 0 .525-.219 1.017-.6 1.379l-.132.116-42.11 33.084a1.93 1.93 0 01-1.215.423c-.289 0-.571-.073-.841-.199a1.91 1.91 0 01-1.095-1.56l-.007-.156v-66.172c0-.735.43-1.398 1.102-1.722a1.965 1.965 0 011.92.13zM31.822 64L69 100.475l-52.046 16.34c-1.984.627-4.098-.394-4.83-2.28l-.07-.192L.188 77.947c-.636-1.952.404-4.032 2.334-4.743l.19-.064zm67.254-21L136 79.14 94.924 92 58 55.866zm64.999-21L201 58.136 159.922 71 123 34.864zm71.782-19.47l.066.19 11.891 37.25a3.918 3.918 0 01-2.334 4.852l-.19.066L226.237 51 189 13.667 231.02.187a3.898 3.898 0 014.837 2.343z"
        opacity={0.02}
      />
    </svg>
  );
}

export default SvgVideoBg;
